import "./notification.css";
import { FaTrashAlt } from "react-icons/fa";
import { IoCheckmarkCircle } from "react-icons/io5";
import userService from "../../services/user.service";
import TimeAgo from "timeago-react";
import moment from "moment";
import { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";
import blankProfile from "./images/blank-profile.png";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FaRegBell, FaTimes } from "react-icons/fa";
import { BsCheckAll } from "react-icons/bs";
import { getFromLocalStorage } from "../../utils/webStorage";
import { connect } from "react-redux";
import {
  openConfirmationPopup,
  openFailDialog,
  openSuccessPopup,
} from "../../Redux/Actions/PopupActions";
import CamelCaseString from "../../Common/CamelCaseString";

class NotificationContainer extends Component {
  constructor(props) {
    super();
    this.state = {
      initialdata: [],
      unReadCount: null,
      showCount: null,
      page: 0,
      totalPage: null,
      submitting: false,
      currentPage: null,
      size: 10,
      redirect: false,
      senderEmail: "",
      currentPageNotifications: 0,
      mergedArrayLength: null,
      deletePopUp: false,
      deleteId: null,
      redirectToVideoEdit: false,
      eventId: "",
      playlistId: "",
      category: "",
      mediaId: "",
      loginRole: "",
      redirectToHighlight: false,
      shareMediaId: "",
      redirectToBreakdownTable: false,
      redirectToStorage: false,
      redirectToSchoolTable: false,
      redirectToStreamingpage: false,
      redirectToHours: false,
    };
  }

  toggleDeleteDialog = (deleteId) => {
    const { deletePopUp } = this.state;
    this.setState({
      deletePopUp: !deletePopUp,
      deleteId,
    });
  };

  getNotification = () => {
    const { page, size } = this.state;
    userService.getNotificationDataByPage(page, size).then((response) => {
      const res = response.data.data;
      this.setState({
        totalPage: res.totalPages,
        initialdata: res.notifications,
        showCount: res.notifications?.length,
        currentPage: res.currentPageNumber,
        unReadCount: res.unreadCount,
      });
    });
  };

  componentDidMount() {
    this.getNotification();
    const loginRole = getFromLocalStorage("loginRole");
    this.setState({ loginRole });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.getNotification();
    }
  }

  GetMoreData = () => {
    const { page, currentPage, showCount, size, initialdata } = this.state;
    this.setState({
      submitting: true,
      page: page + 1,
    });
    userService
      .getNotificationDataByPage(page + 1, size)
      .then((response) => {
        if (response != null) {
          const res = response.data.data.notifications;
          this.setState({
            submitting: false,
            currentPage: currentPage + 1,
            initialdata: initialdata.concat(res),
            showCount: showCount + 10,
            currentPageNotifications: res.length,
            mergedArrayLength: res.length,
          });
        }
      })
      .catch((error) => {
        this.setState({ submitting: false });
      });
  };

  readNotification = (item) => {
    if (item.isRead === false) {
      const { initialdata, unReadCount } = this.state;
      const { notificationUnReadCount, setUnReadCount } = this.props;
      userService
        .readNotificationPost(item.id)
        .then((response) => {
          const NotificationArray = initialdata.map((obj) => {
            if (obj.id === item.id) {
              return { ...obj, isRead: true };
            }
            return obj;
          });
          this.setState({
            initialdata: NotificationArray,
            unReadCount: unReadCount - 1,
          });
          setUnReadCount(notificationUnReadCount - 1);
          this.handleNavigation(item);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      this.handleNavigation(item);
    }
  };

  deleteNotification = (id) => {
    this.toggleDeleteDialog();
    const { initialdata, currentPageNotifications, totalPage, unReadCount } =
      this.state;
    const { setSuccessPopupInformation } = this.props;
    const Currentnotificaton = initialdata.find((data) => data.id === id);
    userService
      .deleteNotificationPost(id)
      .then((response) => {
        if (currentPageNotifications === 1) {
          this.setState({ totalPage: totalPage - 1 });
        }
        if (Currentnotificaton.isRead == false) {
          this.setState({ unReadCount: unReadCount - 1 });
        }
        let NotificationArray = [...initialdata, id];
        NotificationArray = NotificationArray.filter(function (obj) {
          return obj.id !== id;
        });
        this.setState({ initialdata: NotificationArray }, () =>
          setSuccessPopupInformation({
            successPopUp: {
              message: "Notification Removed Successfully!",
              open: true,
            },
          })
        );
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  markAllasRead = () => {
    const { notificationUnReadCount, setUnReadCount, handleClick } = this.props;
    userService
      .getAllUnreadNotifications()
      .then((res) => {
        let notificationIds = [];
        const unReadNotifications = res.data.data[0].notifications;
        for (let i = 0; i < unReadNotifications.length; i++) {
          notificationIds.push(unReadNotifications[i].id);
        }
        const obj = {
          ids: notificationIds,
        };
        userService
          .readAllNotificationPost(obj)
          .then((response) => {
            this.getNotification();
            setUnReadCount(notificationUnReadCount - 1);
            handleClick();
          })
          .catch((error) => {
            console.error("There was an error!", error);
          });
      })
      .catch((err) => {
        console.error("There was an error!", err);
      });
  };

  convertDate = (UtcDate) => {
    var date = moment.utc(UtcDate).format("YYYY-MM-DD HH:mm:ss");
    var stillUtc = moment.utc(date).toDate();
    var local = moment(stillUtc).local().format("YYYY-MM-DD HH:mm:ss");

    return local;
  };

  DeleteDialog = () => {
    const { deletePopUp, deleteId } = this.state;
    return (
      <Dialog
        id="dialogBoxRemove"
        className="dialog-stylee"
        open={deletePopUp}
        onClose={this.toggleDeleteDialog}
      >
        <DialogTitle>
          <div className="row">
            <div className="col-1 text-right ml-auto">
              <FaTimes
                onClick={(event) => {
                  event.stopPropagation();
                  this.toggleDeleteDialog();
                }}
                className="crossview cp"
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="clear10"></div>
          <div className="row">
            <div className="col-12 text-center">
              <p className="fs-20 semi-bold text-center mb-4">
                Are you sure
                <br />
                you want to remove the notification?
              </p>
            </div>
            <div className="col-5 col-md-3 col-lg-3 ml-auto text-center">
              <button
                type="button"
                class="cancelbtn canBtn"
                onClick={(event) => {
                  event.stopPropagation();
                  this.toggleDeleteDialog();
                }}
              >
                No
              </button>
            </div>
            <div className="col-5 col-md-3 col-lg-3 mr-auto text-center ">
              <button
                type="button"
                class="yes-btn delBtn"
                onClick={(event) => {
                  event.stopPropagation();
                  this.deleteNotification(deleteId);
                }}
              >
                Yes, Remove
              </button>
            </div>
          </div>
          <div className="clear10"></div>
          <div className="clear10"></div>
        </DialogContent>
      </Dialog>
    );
  };

  storagePlaylist = (
    seasonId,
    eventType,
    weekName,
    eventCategory,
    offSeasonEventName,
    practiceName
  ) => {
    const { history } = this.props;
    let seasonYear = "";
    let otherEventType = "";
    switch (eventType) {
      case "Other":
        otherEventType = offSeasonEventName;
        seasonYear = seasonId;
        break;

      case "Off-Season":
        seasonYear = seasonId;
        break;

      default:
        seasonYear = seasonId;
        break;
    }
    history.push(
      `/videoPlayer?seasonId=${seasonYear}&eventId=${eventType}&weekId=${weekName}&eventCategory=${eventCategory}&off-season-eventName=${offSeasonEventName}&practice=${practiceName}&otherEventType=${otherEventType}`
    );
  };

  handleNavigation = (item) => {
    const { loginRole } = this.state;
    switch (item.associatedType) {
      case "Contact Us":
        this.setState({
          redirect: true,
          senderEmail: item.senderEmail,
        });
        break;

      case "Save Clip" || "Video Sharing":
        if (loginRole !== "ATHLETE") {
          userService
            .getScheduleDetailsOfEventMedia(item.mediaIds)
            .then((res) => {
              const data = res.data.data;
              this.storagePlaylist(
                data.scheduleEventMedia?.schYear,
                data.scheduleEventMedia?.scheduleEvent?.seasonType,
                `${data.seasonWeeks?.title} - ${data?.opponentName}`,
                data.scheduleEventMedia?.scheduleEvent?.seasonType,
                data.scheduleEventMedia?.scheduleEvent?.eventName,
                data.scheduleEventMedia?.scheduleEvent?.practiceName
              );
            });
        }
        break;

      case "Highlight Video":
        if (loginRole === "SUPER ADMIN") {
          this.setState({
            shareMediaId: item.mediaIds,
            redirectToHighlight: true,
          });
          this.props.closeMenu();
        }
        break;

      case "SPORT HOURS":
        if (loginRole === "SUPER ADMIN") {
          this.setState({ redirectToStorage: true });
          this.props.closeMenu();
        }
        if (loginRole === "SCHOOL ADMIN") {
          this.setState({ redirectToHours: true });
        }
        break;

      //not using
      case "Update Breakdown Values":
        if (loginRole === "SUPER ADMIN") {
          // this.setState({ redirectToBreakdownTable: true });
          this.props.closeMenu();
        }
        break;

      case "Started Stream":
        this.setState({ redirectToStreamingpage: true });
        // this.props.closeMenu();
        break;

      case "Stopped Stream":
        this.setState({ redirectToStreamingpage: true });
        // this.props.closeMenu();
        break;

      default:
        break;
    }
  };

  notificationWithSenderName = (item, messageType) => {
    return (
      <div
        className="border-bottom-black"
        key={item.id}
        onClick={(event) => {
          event.stopPropagation();
          this.readNotification(item);
        }}
      >
        <div
          className={
            item.isRead == false
              ? "msg-container cp active"
              : "msg-container cp"
          }
        >
          <img
            className="sender-profile"
            src={item.image ? item.image : blankProfile}
          />
          <div className="msg-text-container">
            <div className="d-flex-align-cent mg-bt-5">
              <p className="sender-name fs-16 semi-bold">
                {item.senderFirstName} {item.senderLastName}
                <span className="msg-type-show fs-16 semi-bold">
                  {" "}
                  {messageType}
                </span>
              </p>
            </div>
            <p className="msg-content fs-16 semi-bold">{`${CamelCaseString(
              item.message
            )}`}</p>
            <div className="d-flex-space-between mg-tp-5">
              <p className="msg-time">
                <TimeAgo datetime={this.convertDate(item.createdAt)} />
              </p>
              <div>
                {item.isRead ? null : (
                  <IoCheckmarkCircle
                    className="mark-icon icons-effects"
                    onClick={(event) => {
                      event.stopPropagation();
                      this.readNotification(item.id);
                    }}
                  />
                )}
                <FaTrashAlt
                  className="delete-icon icons-effects"
                  onClick={(event) => {
                    event.stopPropagation();
                    this.toggleDeleteDialog(item.id);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  messageContainer = (item) => {
    switch (item.associatedType) {
      case "Video Sharing":
        return this.notificationWithSenderName(item, "(Shared Video)");

      case "Delete Clip":
        return this.notificationWithSenderName(item, "(Deleted Video)");

      case "Save Clip":
        return this.notificationWithSenderName(item, "(Uploaded Videos)");

      case "Contact Us":
        return this.notificationWithSenderName(item, "(Contact Us)");

      case "SPORT HOURS":
        return this.notificationWithSenderName(item, "(Storage Request)");

      case "NEW SCHOOL REGISTRATION":
        return this.schoolRegistrationContainer(item);

      case "Highlight Video":
        return this.notificationWithSenderName(item, "(Highlight Request)");

      case "Update Breakdown Values":
        return this.notificationWithSenderName(
          item,
          "(Update Breakdown values request)"
        );

      case "Breakdown Values":
        return this.notificationWithSenderName(
          item,
          "(Approved Breakdown Values)"
        );

      case "Started Stream":
        return this.notificationWithSenderName(item, "(Streaming)");

      case "Stopped Stream":
        return this.notificationWithSenderName(item, "(Streaming)");

      default:
        break;
    }
  };

  messages = () => {
    const { initialdata, showCount } = this.state;
    return (
      <>
        {initialdata
          .slice(0, showCount)
          .map((item) => this.messageContainer(item))}
        {this.DeleteDialog()}
      </>
    );
  };

  schoolRegistrationContainer = (item) => {
    return (
      <div
        className="border-bottom-black"
        key={item.id}
        onClick={() => {
          if (!item.isRead) {
            this.readNotification(item.id);
          }
          this.setState({ redirectToSchoolTable: true });
        }}
      >
        <div
          className={
            item.isRead == false
              ? "msg-container cp active"
              : "msg-container cp"
          }
        >
          <img
            className="sender-profile"
            src={item.image ? item.image : blankProfile}
          />
          <div className="msg-text-container">
            <div className="d-flex-align-cent mg-bt-5">
              <p className="sender-name fs-16 semi-bold">School Registration</p>
            </div>
            <p className="msg-content semi-bold fs-16">{item?.message}</p>
            <div className="d-flex-space-between mg-tp-5">
              <p className="msg-time">
                <TimeAgo datetime={this.convertDate(item?.createdAt)} />
              </p>
              <div>
                {item.isRead ? null : (
                  <IoCheckmarkCircle
                    className="mark-icon icons-effects"
                    onClick={(event) => {
                      event.stopPropagation();
                      this.readNotification(item?.id);
                    }}
                  />
                )}
                <FaTrashAlt
                  className="delete-icon icons-effects"
                  onClick={(event) => {
                    event.stopPropagation();
                    this.toggleDeleteDialog(item?.id);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      currentPage,
      unReadCount,
      totalPage,
      submitting,
      redirect,
      senderEmail,
      initialdata,
      redirectToHighlight,
      shareMediaId,
      redirectToStorage,
      redirectToSchoolTable,
      redirectToBreakdownTable,
      redirectToStreamingpage,
      redirectToHours,
    } = this.state;

    if (redirect) {
      this.getNotification();
      return <Redirect to={`/admincontactus?email=${senderEmail}`} />;
    }
    if (redirectToHighlight) {
      this.setState({ redirectToHighlight: false });
      return <Redirect to={`/highlightsdetails/${shareMediaId}`} />;
    }
    if (redirectToStorage) {
      this.setState({ redirectToStorage: false });
      return <Redirect to="/storage" />;
    }
    if (redirectToHours) {
      this.setState({ redirectToHours: false });
      return <Redirect to="/hours" />;
    }

    if (redirectToSchoolTable) {
      this.setState({ redirectToSchoolTable: false });
      return <Redirect to="/schools" />;
    }

    if (redirectToBreakdownTable) {
      this.setState({ redirectToBreakdownTable: false });
      return <Redirect to="breakdownRequests" />;
    }

    if (redirectToStreamingpage) {
      this.setState({ redirectToStreamingpage: false });
      return <Redirect to="/videostreamingforschooladmin" />;
    }

    return (
      <div className="notify-container">
        {initialdata.length <= 0 ? (
          <div className="no-notifications">
            <FaRegBell className="bell-icon" />
            <h5 className="txt-center">No notifications yet.</h5>
            <p>When you get notifications, they'll show up here.</p>
          </div>
        ) : (
          <div>
            <div className="notify-header">
              <p className="notify-txt">
                Notifications ({unReadCount ? unReadCount : 0})
              </p>
              {unReadCount !== 0 ? (
                <p className="all-read cp" onClick={this.markAllasRead}>
                  <span className="fs-22">
                    <BsCheckAll />
                  </span>{" "}
                  Mark all as read
                </p>
              ) : null}
            </div>
            <div className="msg-box-container">
              {this.messages()}

              <div className="dflex-space-evenly">
                {currentPage + 1 !== totalPage && totalPage !== 1 ? (
                  <p className="cp showmore-txt" onClick={this.GetMoreData}>
                    {submitting == false ? "Show More" : "Loading..."}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setConfirmationPopupInformation: (obj) =>
      openConfirmationPopup(dispatch, obj),
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return state;
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NotificationContainer)
);
